module.exports = __webpack_public_path__ + "5b774c25787e0a52c013463c9e3c4219.svg";